import { setConditionErrors } from '@/utils/product/errors';
import { escapeRegex } from '@/utils/string';
import { getSize } from '@/utils/iterable/getSize';
import { get } from '@/utils/iterable/get';

import { FIND, OPERATIONS, REPLACE } from '@/constants/bulkEdit';
import { AMOUNT, ERROR, VALUE } from '@/constants/product';
import { ATTRIBUTE } from '@/constants/attributes';
import { ERRORS } from '@/constants/validations';
import { EBAY } from '@/constants/channels';
import { FORM } from '@/constants/forms';
import { DATA } from '@/data';

export default function conditionDescription({ actions, operation, product, shop }) {
  const category = product.getIn([FORM.DETAILS, ATTRIBUTE.ITEM_CATEGORY, VALUE]);

  if (!category || category === AMOUNT.ZERO) {
    return { actions, product };
  }

  const marketplaceId = shop.get('marketplaceId');
  const conditionIds = get([EBAY, marketplaceId, 'CATEGORIES', category, 'conditions', 'ids'])(DATA);

  if (getSize(conditionIds) === 0) {
    return { actions, product };
  }

  const condition = getSize(conditionIds) === 1
    ? conditionIds[0]
    : product.getIn([FORM.DETAILS, ATTRIBUTE.CONDITION, VALUE]);

  if (condition === '1000') {
    return { actions, product };
  }

  function validateAndApply(value) {
    const validated = setConditionErrors({
      product: product.setIn([FORM.DETAILS, ATTRIBUTE.CONDITION, ATTRIBUTE.DESCRIPTION], value),
      shop,
    });

    if (validated.getIn([FORM.DETAILS, ATTRIBUTE.CONDITION, ERROR]) !== ERRORS.DETAILS.CONDITION_DESCRIPTION) {
      return { actions, product : validated };
    }

    return { actions, product };
  }

  switch (operation.get('type')) {
    case OPERATIONS[EBAY].CONDITION_DESCRIPTION.ADD_AFTER: {
      const productValue = product.getIn([FORM.DETAILS, ATTRIBUTE.CONDITION, ATTRIBUTE.DESCRIPTION]) || '';
      const operationValue = operation.get('value') || '';
      const value = `${productValue}${operationValue}`;
      return validateAndApply(value);
    }

    case OPERATIONS[EBAY].CONDITION_DESCRIPTION.ADD_BEFORE: {
      const productValue = product.getIn([FORM.DETAILS, ATTRIBUTE.CONDITION, ATTRIBUTE.DESCRIPTION]) || '';
      const operationValue = operation.get('value') || '';
      const value = `${operationValue}${productValue}`;
      return validateAndApply(value);
    }

    case OPERATIONS[EBAY].CONDITION_DESCRIPTION.DELETE: {
      const productValue = product.getIn([FORM.DETAILS, ATTRIBUTE.CONDITION, ATTRIBUTE.DESCRIPTION]) || '';
      const operationValue = operation.get('value') || '';
      const pattern = new RegExp(escapeRegex(operationValue), 'ig');
      const value = productValue.replace(pattern, '');
      return validateAndApply(value);
    }

    case OPERATIONS[EBAY].CONDITION_DESCRIPTION.FIND_AND_REPLACE: {
      const productValue = product.getIn([FORM.DETAILS, ATTRIBUTE.CONDITION, ATTRIBUTE.DESCRIPTION]) || '';
      const operationValue = operation.get('value') || '';
      const pattern = new RegExp(escapeRegex(operationValue.get(FIND)), 'ig');
      const value = productValue.replace(pattern, operationValue.get(REPLACE));
      return validateAndApply(value);
    }

    case OPERATIONS[EBAY].CONDITION_DESCRIPTION.SET: {
      const operationValue = operation.get('value') || '';
      return validateAndApply(operationValue);
    }

    default: {
      return { actions, product };
    }
  }
}
